import { Component, OnInit } from '@angular/core';
import {StateService} from '@core/services/state.service';

@Component({
  selector: 'app-news-page-wrapper',
  templateUrl: './news-page-wrapper.component.html',
  styleUrls: ['./news-page-wrapper.component.scss']
})
export class NewsPageWrapperComponent implements OnInit {

  smallScreenSize: boolean;
  public isBrowser = StateService.isBrowser;

  constructor() { }

  ngOnInit() {
    const tabletBreakpoint = 768;
    if (StateService.isBrowser) {
      this.smallScreenSize = window.innerWidth < tabletBreakpoint;
    }
  }
}
